import axiosInstance from "../api/axios";

/* Channel-partner-facing referral commissions (scoped server-side to the calling CP). */

// Referral commissions this channel partner owes BuildVizer (all statuses).
export const getCpCommissions = () => axiosInstance.get(`/referrals/cp/commissions`);

// Record an offline remittance of the BV cut; moves the reward to awaiting BV validation.
// body: { reference, amount, proofUrl? }
export const submitCpRemittance = (rewardId, body) =>
  axiosInstance.post(`/referrals/cp/commissions/${rewardId}/remit`, body);
